/**
 * Texto que chegou por "compartilhar" (de outro app ou de dentro do próprio
 * Secretário): fica guardado até a conversa escolhida abrir, já no campo de
 * mensagem, para a pessoa conferir e enviar.
 */
const PREFIX = 'secretario.compartilhar.';

export const SHARE_PICK_EVENT = 'secretario:compartilhar';

export type SharePickDetail = { text: string; files?: File[] };

/** "Conversa" do Secretário nos atalhos de compartilhar (a página dele é /conversas/secretario). */
export const SECRETARY_ROOM = 'secretario';

// Arquivos compartilhados esperando a conversa abrir (só nesta sessão do app).
const sharedFiles = new Map<string, File[]>();

export function setShareFiles(roomId: string, files: File[]): void {
  if (files.length) sharedFiles.set(roomId, files.slice(0, 4));
}

export function takeShareFiles(roomId: string): File[] {
  const files = sharedFiles.get(roomId) ?? [];
  sharedFiles.delete(roomId);
  return files;
}

// Para o Secretário: texto e anexos vão na hora, assim que a conversa com ele abre.
let secretaryShare: { text: string; files: File[] } | null = null;

export function setSecretaryShare(text: string, files: File[]): void {
  secretaryShare = { text: text.slice(0, 2000), files: files.slice(0, 4) };
}

export function takeSecretaryShare(): { text: string; files: File[] } | null {
  const share = secretaryShare;
  secretaryShare = null;
  return share;
}

export function setShareDraft(roomId: string, text: string): void {
  try {
    window.sessionStorage.setItem(PREFIX + roomId, text.slice(0, 4000));
  } catch {
    /* sem armazenamento: a conversa abre com o campo vazio */
  }
}

export function takeShareDraft(roomId: string): string | null {
  try {
    const text = window.sessionStorage.getItem(PREFIX + roomId);
    if (text !== null) window.sessionStorage.removeItem(PREFIX + roomId);
    return text;
  } catch {
    return null;
  }
}

/** Abre a folha para escolher quem recebe o texto (e os arquivos, quando vieram). */
export function pickConversationFor(text: string, files: File[] = []): void {
  window.dispatchEvent(
    new CustomEvent<SharePickDetail>(SHARE_PICK_EVENT, { detail: { text, files } }),
  );
}
